import React from 'react';
import { Link } from 'react-router-dom';
import './Pricing.css';

function Pricing() {
  const plans = [
    {
      name: 'Bronze',
      price: 'Contact Us',
      description: 'Perfect for small teams starting their wellbeing journey',
      features: [
        'Up to 50 users',
        'Daily F-IT check-ins',
        'Basic dashboard analytics',
        'Monthly reports',
        'Email support',
        'Anonymous data aggregation'
      ],
      color: 'bronze'
    },
    {
      name: 'Silver',
      price: 'Contact Us',
      description: 'Ideal for growing organisations',
      features: [
        'Up to 200 users',
        'Daily F-IT check-ins',
        'Advanced analytics dashboard',
        'Real-time alerts',
        'Department-level insights',
        'Monthly deep dive assessments',
        'Priority email support',
        'Custom branding'
      ],
      color: 'silver',
      popular: true
    },
    {
      name: 'Gold',
      price: 'Contact Us',
      description: 'For established companies serious about culture',
      features: [
        'Up to 500 users',
        'All Silver features',
        'Crisis intervention tools',
        'Mental health first aider management',
        'Custom integration options',
        'Quarterly strategy sessions',
        'Dedicated account manager',
        'API access'
      ],
      color: 'gold'
    },
    {
      name: 'Platinum',
      price: 'Custom',
      description: 'Enterprise solution with full customization',
      features: [
        'Unlimited users',
        'All Gold features',
        'White-label solution',
        'Custom feature development',
        'On-premise deployment option',
        'Multi-company management',
        'Training & workshops',
        '24/7 priority support'
      ],
      color: 'platinum'
    }
  ];

  return (
    <div className="pricing-page">
      <section className="pricing-hero">
        <div className="container">
          <h1>Choose Your Plan</h1>
          <p className="lead">Flexible pricing for organisations of all sizes</p>
        </div>
      </section>

      <section className="pricing-plans">
        <div className="container">
          <div className="plans-grid">
            {plans.map((plan, index) => (
              <div key={index} className={`plan-card ${plan.color} ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <div className="popular-badge">Most Popular</div>}
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">{plan.price}</div>
                <p className="plan-description">{plan.description}</p>
                <ul className="plan-features">
                  {plan.features.map((feature, idx) => (
                    <li key={idx}>
                      <span className="check">✓</span> {feature}
                    </li>
                  ))}
                </ul>
                <Link to="/demo" className="btn btn-plan">Request Demo</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pricing-faq">
        <div className="container">
          <h2 className="section-title">Pricing FAQs</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>Is there a free trial?</h3>
              <p>Yes! We offer a 30-day free trial for all plans. No credit card required. Experience the full power of F-IT Score risk-free.</p>
            </div>
            <div className="faq-item">
              <h3>Can I upgrade or downgrade?</h3>
              <p>Absolutely. Switch between plans at any time as your needs change. Your data transfers seamlessly between tiers.</p>
            </div>
            <div className="faq-item">
              <h3>What's included in setup?</h3>
              <p>All plans include onboarding support, user training materials, and integration assistance to get you up and running quickly.</p>
            </div>
            <div className="faq-item">
              <h3>How is pricing calculated?</h3>
              <p>Pricing is based on the number of active users and features needed. Contact us for a custom quote tailored to your organisation.</p>
            </div>
            <div className="faq-item">
              <h3>Do you offer discounts?</h3>
              <p>Yes! We provide special pricing for non-profits, educational institutions, and annual commitments. Get in touch to learn more.</p>
            </div>
            <div className="faq-item">
              <h3>What about data privacy?</h3>
              <p>All plans include enterprise-grade security, GDPR compliance, and complete data privacy protection at no extra cost.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container cta-box">
          <h2>Not Sure Which Plan is Right?</h2>
          <p>Let's chat! Our team will help you find the perfect fit for your organisation's needs and budget.</p>
          <div className="cta-buttons">
            <Link to="/demo" className="btn btn-orange">Schedule a Demo</Link>
            <Link to="/contact" className="btn btn-outline">Contact Sales</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Pricing;
